/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <!-- <group-bankcard-list v-if="isGroup && !storeId"/> -->
    <store-bankcard-lists/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupBankcardList from './GroupBankcardList'
  import StoreBankcardLists from './StoreBankcardLists'

  export default {
    name: 'GroupBankcardBus',
    components: { StoreBankcardLists, GroupBankcardList },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
